export default "__VITE_ASSET__5au1_6QB__"